import { SOCKET_RETRY_BASE_MS, SOCKET_RETRY_MAX_MS } from '@/lib/socket/socket.session.events';

export const socketReconnectDelay = (attempt: number, random: () => number = Math.random): number => {
    const ceiling = Math.min(SOCKET_RETRY_MAX_MS, SOCKET_RETRY_BASE_MS * 2 ** Math.min(Math.max(attempt, 0), 16));
    return Math.round(SOCKET_RETRY_BASE_MS / 2 + random() * (ceiling - SOCKET_RETRY_BASE_MS / 2));
};

export default socketReconnectDelay;
